export class MygooruSerializer {

    static get instance() {
        return this.INSTANCE;
    }

    private static INSTANCE = new MygooruSerializer();

    public normalizeReportsData(input: any) {
        const { context, data } = input;

        if (!data || data.length === 0) {
            return { context, data };
        }
        const [response] = data;
        return {
            context,
            drillDown: response.drillDown,
            overallStats: response.overall_stats,
            coordinates: response.coordinates,
        };
    }
}
export const mygooruSerializer = MygooruSerializer.instance;
